// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  name: 'qa-na',
  production: false,
  region: 'NA',
  appUrl: 'https://managed-event-registry.qa.zonarsystems.net/',

  apiBase: {
    url: 'https://zonar-nonprod-qa.apigee.net'
  },

  coreEntityApiBase: {
    url: 'https://api-qa.zonarsystems.net/core/v1'
  },

  userPreferencesApiBase: {
    url: 'https://api-qa.zonarsystems.net/alert/v1'
  },

  authEnv: 'qa',

  auth: {
    clientID: 'iNOZ4TyWxPnk1uPeoIehHpIJjsj4DtrP',
    domain: 'qa-login.zonarsystems.net',
    audience: 'http://apiqa.zonarsystems.net/',
    // These come from the Core APIs as your application is built.
    applicationId: '1f645d78-dc68-46fb-9c82-6af6df96826b',
    defaultZonarRole: 'cbf13972-aad5-4e69-bc5c-c11af89d88bc',
    useRefreshTokens: true
  },

  pendo: {
    url: 'https://cdn.pendo.io/agent/static/'
  },

  googleTagManager: {
    id: 'GTM-PM9R42P',
    auth: '',
    environment: ''
  },

  datadog: {
    applicationId: 'ae864ef9-6e2d-453b-b0ac-999c8219618a',
    clientToken: 'pub8b104aad726d6366de4823da4068593b',
    site: 'us5.datadoghq.com',
    tagEnvironment: 'qa'
  },

  i18n: {
    supportedLanguages: [
      'en',
      'en-US',
      'de-DE',
      'en-GB',
      'it',
      'fr-FR',
      'de',
      'es-ES'
    ],
    defaultLanguage: 'en-US'
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
